import { RenderStateStruct, WordArtRenderProps } from '../../type';

export function renderChar({
    renderStateStruct,
    rectTextList,
}: {
    renderStateStruct: RenderStateStruct;
    rectTextList: WordArtRenderProps['rectTextList'];
}) {
    const { scheduleRatio } = renderStateStruct;

    rectTextList.forEach((rectText, id) => {
        const { fontStyle, fontWeight, fontSize, fontFamily } = rectText;
        const font = `${fontStyle} ${fontWeight} ${fontSize * scheduleRatio}px ${fontFamily}`;

        if (!rectText.alpha) return;

        renderStateStruct.charStructList.push({
            id,
            char: rectText.content,
            font,
            width: (rectText.width * scheduleRatio) >> 0,
            height: (rectText.height * scheduleRatio) >> 0,
            offset: {
                x: rectText.localBounds.x * scheduleRatio,
                y: rectText.localBounds.y * scheduleRatio,
                rectXOffset: rectText.rectXOffset * scheduleRatio,
                rectYOffset: rectText.rectYOffset * scheduleRatio,
            },
            detail: rectText,
            bounds: undefined,
            center: undefined,
            cmds: undefined,
        });
    });
}
